/**
 * A trilha do que já foi respondido — **sem total, e sem barra**.
 *
 * Um formulário com ramificação não sabe quantas perguntas faltam: o próximo nó
 * depende do que ainda vai ser respondido. Uma barra de progresso ali mostraria
 * uma porcentagem inventada, e inventar número é o que esta ferramenta existe
 * para não fazer. O que dá para dizer com verdade é o que já passou — e é só
 * isso que está aqui.
 *
 * Fica DEPOIS da pergunta atual, e não antes: com oito respostas dadas, a lista
 * empurraria a pergunta para baixo da dobra no celular. Ela é comprovante, não
 * navegação — voltar não existe, porque o motor recusa responder fora de ordem.
 */

import type { Trilho } from '../../ganchos/useConvite';
import { textoDoValor } from './valores';

export function Trilha({ itens }: { readonly itens: readonly Trilho[] }) {
  if (itens.length === 0) return null;

  return (
    <section className="trilha" aria-labelledby="trilha-rotulo">
      <h3 className="trilha__rotulo" id="trilha-rotulo">
        O que você já respondeu
      </h3>
      <dl className="trilha__lista">
        {itens.map((item) => (
          <div className="trilha__item" key={item.noId}>
            <dt className="trilha__pergunta">{item.rotulo}</dt>
            <dd className="trilha__resposta">{textoDoValor(item.valor, item.subtipo)}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
